import { useEffect, useState } from 'react';
import { api } from '../api';
import type { Post } from '../types';
import { PostCard } from '../components/PostCard';
import { PostComposer } from '../components/PostComposer';

/** The posts feed: your posts and everyone you follow. */
export function PostsPage() {
  const [posts, setPosts] = useState<Post[] | null>(null);
  const [hasMore, setHasMore] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => { api.feedPosts().then((r) => { setPosts(r.posts); setHasMore(r.hasMore); }).catch((e) => setError(e.message)); }, []);

  const more = async () => {
    if (!posts?.length) return;
    setLoadingMore(true);
    try {
      const r = await api.feedPosts(posts[posts.length - 1].createdAt);
      setPosts([...posts, ...r.posts]);
      setHasMore(r.hasMore);
    } catch (e: any) { setError(e.message); } finally { setLoadingMore(false); }
  };
  const del = async (id: string) => { try { await api.deletePost(id); setPosts((p) => (p ?? []).filter((x) => x.id !== id)); } catch (e: any) { setError(e.message); } };

  return (
    <div className="stack">
      <PostComposer onPosted={(p) => setPosts([p, ...(posts ?? [])])} />
      {error && <div className="error">{error}</div>}
      {posts === null ? <div className="spinner">Loading…</div> : posts.length === 0 ? (
        <div className="empty">Nothing here yet. Post something, or follow people from their profiles to see their posts.</div>
      ) : posts.map((p) => <PostCard key={p.id} post={p} onDelete={del} />)}
      {hasMore && <button className="btn secondary block" disabled={loadingMore} onClick={more}>{loadingMore ? 'Loading…' : 'Load more'}</button>}
    </div>
  );
}
